export { default } from './CheckoutTips';
